import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getBelongingsData(context) {
      const response = await Vue.axios.get(`${URL_API}belonging`);
      let data = response["data"];
      context.commit("updateBelongingsData", data);
    },
    async createBelongingData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}belonging/store`, body, config);
      context.dispatch("getBelongingsData");
    },
    async pushBelongingData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}belonging/update`, body, config);
      context.dispatch("getBelongingsData");
    },
    async destroyBelongingData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}belonging/destroy`, body, config);
      context.dispatch("getBelongingsData");
    }
  },
  mutations: {
    updateBelongingsData(state, belongingsData) {
      state.belongingsData = belongingsData;
    }
  },
  state: {
    belongingsData: []
  },
  getters: {
    allBelongingsData(state) {
      return state.belongingsData;
    }
  }
};
